import React, { useState } from "react";
import TeamService from "services/TeamService";
import { useMoodsContext } from "store/contexts/moodsContext";
import { useTimelineContext } from "store/contexts/timelineContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTeamContext } from "store/contexts/teamContext";
import { faSmile } from "@fortawesome/free-solid-svg-icons";
import { CSSTransition } from "react-transition-group";
import ClickAwayListener from "react-click-away-listener";
import { useUserContext } from "store/contexts/userContext";
import classNames from "classnames";

var styles = {
  emoji: {
    width: "23px",
    height: "23px",
  },
  selectedEmoji: {
    width: "100%",
    height: "100%",
  },
  everyEmoji: {
    paddingTop: "8px",
    paddingBottom: "8px",
    borderLeft: "1px solid aliceblue",
    borderRight: "1px solid aliceblue",
    paddingLeft: "10px",
    paddingRight: "10px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  emojiList: {
    display: "flex",
    listStyle: "none",
  },
  boxShadow: {
    background: "white",
    boxShadow:
      "0px 2px 1px -1px rgb(0 0 0 / 20%), 0px 1px 1px 0px rgb(0 0 0 / 14%), 0px 1px 3px 0px rgb(0 0 0 / 12%)",
  },
  moodName: {
    color: "#575f6b",
    fontSize: "10px"
  }
};

export default ({ listTask }) => {
  const { team } = useTeamContext();
  const classes = styles;
  const [showMoods, setShowMoods] = useState(null);
  const { buzzes } = useMoodsContext();
  const { updateTask } = useTimelineContext();
  const { user } = useUserContext();

  const showMoodsPooper = (event) => {
    setShowMoods(event.currentTarget);
  };

  const hideMoodsPooper = () => {
    setShowMoods(null);
  };

  const clearTodoTaskReaction = (event) => {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();

    setShowMoods(null);
    const listTaskCopy = { ...listTask };

    if (listTask.buzz_type_id) {
      listTaskCopy.buzzes_count -= 1;

      var allReactions = listTaskCopy.reactions.filter(
        (reaction) => reaction.user.id !== user.id
      );

      listTaskCopy.reactions = allReactions;
    }

    listTaskCopy.buzz_type_id = null;

    TeamService.clearTodoReaction(team.id, listTask.todo_list_id, listTask.id);
    updateTask(listTaskCopy);
  };

  const updateReaction = (newReactionId, event) => {
    event.preventDefault();
    event.stopPropagation();
    event.nativeEvent.stopImmediatePropagation();

    if (newReactionId === listTask?.buzz_type_id) {
      clearTodoTaskReaction(event);
      return;
    }

    setShowMoods(null);
    const listTaskCopy = { ...listTask };

    if (!listTask.buzz_type_id) {
      listTaskCopy.buzzes_count += 1;
    }

    listTaskCopy.buzz_type_id = newReactionId;
    listTaskCopy.reactions = null;

    TeamService.reactToListTask(
      team.id,
      listTask.todo_list_id,
      listTask.id,
      newReactionId
    );
    updateTask(listTaskCopy);
  };

  let selectedMood = buzzes?.find((buzzes) => {
    return buzzes?.id === listTask?.buzz_type_id;
  });

  selectedMood = selectedMood ? (
    <img
      className="mwh-15"
      style={classes.selectedEmoji}
      src={selectedMood.media}
      alt={selectedMood.name}
    />
  ) : (
    <FontAwesomeIcon
      icon={faSmile}
      style={classes.selectedEmoji}
      className="mwh-15"
    />
  );

  return (
    <div
      style={classes.relative}
      onMouseEnter={showMoodsPooper}
      onClick={showMoodsPooper}
      onMouseLeave={hideMoodsPooper}
      className="p-like-btn"
    >
      {listTask?.buzz_type_id && selectedMood}
      {!listTask?.buzz_type_id && (
        <FontAwesomeIcon
          className="mwh-15"
          style={classes.selectedEmoji}
          icon={faSmile}
        />
      )}
      <CSSTransition
        in={Boolean(showMoods)}
        timeout={300}
        unmountOnExit
        classNames="reaction-element"
      >
        <ClickAwayListener onClickAway={hideMoodsPooper}>
          <div style={classes.boxShadow} className="postMoods">
            <ul style={classes.emojiList}>
              {buzzes?.map((mood) => (
                <li
                  className={classNames({
                    "emoji-mood": true,
                    "selected_emoji_mood": listTask.buzz_type_id === mood.id ? true : false,
                  })}
                  onClick={(e) => updateReaction(mood.id, e)}
                  key={mood.name}
                  style={classes.everyEmoji}
                >
                  <img
                    src={mood.media}
                    alt={mood.name}
                    key={mood.id}
                    style={classes.emoji}
                  />
                  <span style={classes.moodName}>{mood.name}</span>
                </li>
              ))}
            </ul>
          </div>
        </ClickAwayListener>
      </CSSTransition>
    </div>
  );
};
